import { render, staticRenderFns } from "./PDFPreview.vue?vue&type=template&id=0deb48de&scoped=true"
import script from "./PDFPreview.vue?vue&type=script&lang=js"
export * from "./PDFPreview.vue?vue&type=script&lang=js"
import style0 from "./PDFPreview.vue?vue&type=style&index=0&id=0deb48de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deb48de",
  null
  
)

export default component.exports